import Util from '@/lib/util'
import _ from "lodash";

export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width: 80,
        align:"center"
      },
    {
        title:Util.L('Đối tác'),
        key:'product',
        width: 150,
        render:(h:any,params:any)=> { return h("span", !_.isEmpty(_.get(params,'row.product.clientCode')) ? (_.get(params,'row.product.clientCode') + '-' + _.get(params,'row.product.clientName')) : params.row.clientName); }         
    },
    {
        title:Util.L('Ngành hàng cha'),
        key:'categoryName',
        width: 120,
        render:(h:any,params:any)=> { return h("span",!_.isEmpty(_.get(params,'row.product.productCategory.parentCategory')) ? _.get(params,'row.product.productCategory.parentCategory.code','') + ' - ' + _.get(params,'row.product.productCategory.parentCategory.name','') : (!_.isEmpty(_.get(params,'row.productCategory.parentCategory')) ? _.get(params,'row.productCategory.parentCategory.code','') + ' - ' + _.get(params,'row.productCategory.parentCategory.name','') : null)) }
    },{
        title:Util.L('Ngành hàng'),
        key:'product',
        width: 120,
        render:(h:any,params:any)=> { return h("span", !_.isEmpty(_.get(params,'row.product.productCategory.code')) ? _.get(params,'row.product.productCategory.code')  + '-' +  _.get(params,'row.product.productCategory.name') : params.row.categoryName); }
    },
    {
        title:Util.L('Mã sản phẩm'),
        key:'shortName',
        width: 120,
        render:(h:any,params:any)=> { return h("span", _.get(params,'row.product.sku') || params.row.sku); }
    },
    {
        title:Util.L('Tên sản phẩm'),
        key:'shortName',
        render:(h:any,params:any)=> { return h("span", _.get(params,'row.product.name')  || params.row.name); }
    },
    {
        title:Util.L('Thời gian được phép KHBH(ngày)'),
        key:'duration',
        width: 120,
        align: 'right',
        slot: 'duration',
    },
    {
        title: ' ',
        width:100,
        fixed:'right',
        slot: 'action',
        align: 'center'
    }]

